import { render, staticRenderFns } from "./ListDeposit.vue?vue&type=template&id=36fff283&"
import script from "./ListDeposit.vue?vue&type=script&lang=js&"
export * from "./ListDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports